import {config as numberColumnConfig} from '../../common/NumberColumn';

const prop = 'pAUnAsgn';
export const id = 'preparerNotAssigned';

export const config = (labels) => numberColumnConfig({fullId: id, label: labels.preparerNotAssigned, prop});
